// Footer.js
import React from 'react';
import styled from 'styled-components';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaWhatsapp, FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn, FaAngleRight, FaRegCalendarAlt, FaUserMd, FaBriefcase, FaLock , Home} from 'react-icons/fa';
import { AiFillHome } from "react-icons/ai";
import { BiDetail } from "react-icons/bi";
import { MdMedicalServices } from "react-icons/md";
import { MdOutlinePermContactCalendar } from "react-icons/md";
import { FaSitemap } from "react-icons/fa";
import { LuBadgeHelp } from "react-icons/lu";



// Assuming your logo path is correct
import Logo from '../../src/assets/rr.png'; // Update this path to your actual logo image
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        {/* Column 1: Logo & Description */}
        <Column>
          <LogoWrapper>
              <img src={Logo} alt="isha health care Logo" />
          </LogoWrapper>
          <HospitalDescription>
            Isha Health Care under Dr. Raj Kamal is a specialty care diabetes Centre with state-of-the-art technology and providing sophisticated and specialized medical services at affordable costs in Diabetes and its related specialties.
          </HospitalDescription>
        </Column>

        {/* Column 2: Quick Links */}
        <Column>
          <ColumnTitle>Quick Links</ColumnTitle>
          <LinkList>
            <LinkItem><FaRegCalendarAlt /> <FooterLink to="/book-appointment">Appointments</FooterLink></LinkItem>
            <LinkItem><AiFillHome /> <FooterLink to="/">Home</FooterLink></LinkItem>
        
            <LinkItem><FaUserMd /> <FooterLink to="/doctors">Know your Doctor </FooterLink></LinkItem>
            <LinkItem><MdOutlinePermContactCalendar /> <FooterLink to="/contact-us">Contact Us</FooterLink></LinkItem>
            <LinkItem><LuBadgeHelp /> <FooterLink to="/patient-welfare/complain-form">Write your Complaint</FooterLink></LinkItem>
            <LinkItem><FaLock /> <FooterLink to="/privacy-policy">Privacy Policy</FooterLink></LinkItem>
            <LinkItem><FaSitemap /> <FooterLink to="/sitemap">Sitemap</FooterLink></LinkItem>
          </LinkList>
        </Column>

        {/* Column 3: Useful Links */}
        <Column>
          <ColumnTitle>All About Diabetes</ColumnTitle>
          <LinkList>
            <LinkItem><StyledFaAngleRight /> <FooterLink to="/what-is-diabetes?">What is Diabetes?</FooterLink></LinkItem>
            <LinkItem><StyledFaAngleRight /> <FooterLink to="/Types-of-diabetes">Types of diabetes</FooterLink></LinkItem>
            <LinkItem><StyledFaAngleRight /> <FooterLink to="/diabetes-treatment">Diabetes Treatment</FooterLink></LinkItem>
            <LinkItem><StyledFaAngleRight /> <FooterLink to="/diabetes-symptoms">Diabetes Symptoms</FooterLink></LinkItem>
            <LinkItem><StyledFaAngleRight /> <FooterLink to="/diabetes-prevention">Diabetes Prevention</FooterLink></LinkItem>
            <LinkItem><StyledFaAngleRight /> <FooterLink to="/diabetes-faqs?">Diabetes FAQs</FooterLink></LinkItem>
           
          </LinkList>
        </Column>

        {/* Column 4: Contact Us */}
        <Column>
          <ColumnTitle>Contact Us</ColumnTitle>
          <ContactInfo>
            <ContactItem><FaPhoneAlt /> <a href='tel:9835455222'>+91 983 54 55 222</a> </ContactItem>
            <ContactItem><FaPhoneAlt /> <a href='tel:930888006'>+91-930 888 006</a> </ContactItem>
            
            {/* <ContactItem><FaEnvelope /> info@dpmhhospital.com</ContactItem> */}
            <ContactItem address>
              <FaMapMarkerAlt /> 
              <div>
                वेस्ट बजरंगपुरी, गायघाट, पटना 800007, बिहार
              </div>
            </ContactItem>
          </ContactInfo>
          <SocialIcons>
            <SocialIcon href="https://www.facebook.com/drrajkamalihc" target="_blank"><FaFacebookF /></SocialIcon>
            <SocialIcon href="https://www.instagram.com/drrajkamal82ishahealthcare/" target="_blank"><FaInstagram /></SocialIcon>
            <SocialIcon href="https://www.youtube.com/@DrRajKamal82" target="_blank"><FaYoutube /></SocialIcon>
          
          </SocialIcons>
        </Column>
      </FooterContent>

      {/* Copyright Section */}
      <CopyrightSection>
        <p>Copyright © 2026 Isha Health Care, Dr Raj Kamal. All Rights Reserved. managed and developed by <a href="https://www.srksoftwares.com" target="_blank" rel="noopener noreferrer">Er Ajay Thakur</a></p>
        <ChatButtonWrapper>
            <ChatButton href="https://wa.me/+919835455222" target="_blank">
                Chat with us
                <FaWhatsapp />
            </ChatButton>
        </ChatButtonWrapper>
      </CopyrightSection>
    </FooterContainer>
  );
};

// --- Styled Components ---

const FooterContainer = styled.footer`
  background-color: brown; 
  color: #fff;
  font-family: Arial, sans-serif; 
  padding-top: 50px; 
  position: relative; 
`;

const FooterContent = styled.div`
  display: flex;
  flex-wrap: wrap; 
  justify-content: space-between;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 15px; 
  padding-bottom: 30px; 
  color: #fff;

  @media (max-width: 992px) {
    justify-content: center; 
  }
`;

const Column = styled.div`
  flex: 1; 
  min-width: 250px; 
  margin-bottom: 30px; 
  padding: 0 15px; 
  max-width:450px;
  

  &:first-child {
    flex-basis: 30%; 
    min-width: 300px;
  }

  @media (max-width: 992px) {
    flex-basis: 100%;
    text-align: left;
    min-width: unset;
    display: flex;
    align-items: flex-start;
  justify-content: flex-start;
  flex-direction:column;

    &:first-child {
      flex-basis: 100%;
      min-width: unset;
      margin-bottom: 20px;
    }
  }
`;

const LogoWrapper = styled.div`
  margin-bottom: 20px;
 background-color: #fff;
 border-radius: 10px;
 padding-bottom: 5px;

  img {
    max-width: 100%;
    height: 80px; 
    display: block; 
    
    @media (max-width: 992px) {
        margin: 0 auto; 
    }
  }
`;

const HospitalDescription = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  color: #ffffff;


  @media (max-width: 992px) {
    padding: 0 20px; 
  }
`;

const ColumnTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 25px;
  color: #fff;
  position: relative;
  padding-bottom: 10px; 

  &::after {
    content: '';
    position: absolute;
    left: ${props => props.align === 'center' ? '50%' : '0'};
    transform: ${props => props.align === 'center' ? 'translateX(-50%)' : 'none'};
    bottom: 0;
    width: 50px; /* Shorter underline */
    height: 3px;
    background-color: #00bfff; /* Bright blue underline */
  }

  @media (max-width: 992px) {
    text-align: center;
    &::after {
        left: 50%;
        transform: translateX(-50%);
    }
  }
`;

const LinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  @media (max-width: 600px){
      display:flex;
  align-items:flex-start;
  justify-content: flex-start;
  flex-direction: column;
  }
`;

const LinkItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 0.9rem;
  color: #ffffff; /* Lighter text color */

  svg {
    margin-right: 10px;
    color: #00bfff; /* Bright blue icon */
    font-size: 0.8rem; /* Smaller icon for list items */
  }

  /* Specific style for address item */
  ${props => props.address && `
    align-items: flex-start; /* Align icon to top for multi-line address */
    line-height: 1.6;
    div {
        flex: 1; /* Allow address text to take remaining space */
    }
    svg {
        margin-top: 3px; /* Align icon better with first line of text */
    }
  `}

  @media (max-width: 992px) {
    justify-content: center;
    text-align: left; /* Keep text left aligned even if parent is centered */
  }
`;

// Specific style for the small arrow icon
const StyledFaAngleRight = styled(FaAngleRight)`
    font-size: 0.7rem !important; /* Smaller size for the arrow */
    margin-top: 2px; /* Slight adjustment */
`;


const FooterLink = styled(Link)`
  color: #ffffff;
  text-decoration: none;
  transition: color 0.3s;

  &:hover {
    color: #00bfff; /* Bright blue on hover */
  }
`;

const ContactInfo = styled.div`
  margin-bottom: 20px;

  @media (max-width:600px){
    display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 0.9rem;
  color: #ffffff;
  line-height: 1.4;

  svg {
    margin-right: 10px;
    color: #00bfff;
    font-size: 1.1rem;
    flex-shrink: 0; /* Prevent icon from shrinking */
  }

  ${props => props.address && `
    align-items: flex-start;
    svg {
      margin-top: 3px;
    }
  `}
  
  @media (max-width: 992px) {
    justify-content: center;
    text-align: left;
    padding: 0 20px; /* Add padding to prevent text from touching edges */
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;

  @media (max-width: 992px) {
    justify-content: center;
    margin-top: 20px; /* Add space above social icons on mobile */
  }
`;

const SocialIcon = styled.a`
  color: #fff;
  font-size: 1.3rem;
  width: 35px;
  height: 35px;
  background-color: #3b508f; /* Slightly lighter dark blue for icon background */
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s, color 0.3s;

  &:hover {
    background-color: #00bfff; /* Bright blue on hover */
    color: #fff;
  }
`;

const CopyrightSection = styled.div`
  background-color: brown; /* Even darker blue for copyright strip */
  padding: 20px 5%;
  text-align: center;
  font-size: 0.85rem;
  color: #ffffff;
  position: relative; /* For the chat button to be positioned relative to this section */
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    margin: 0;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 15px;
    font-size: 0.8rem;
  }
`;

const ChatButtonWrapper = styled.div`
  position: fixed; /* Fixed position for the chat button */
  bottom: 20px;
  right: 20px;
  z-index: 1000; /* Ensure it's above other content */

  @media (max-width: 768px) {
    bottom: 15px;
    right: 15px;
  }
`;

const ChatButton = styled.a`
  display: flex;
  align-items: center;
  background-color: #25d366; /* WhatsApp green */
  color: white;
  padding: 10px 15px;
  border-radius: 50px; /* Pill shape */
  text-decoration: none;
  font-size: 1rem;
  font-weight: 600;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s;
  white-space: nowrap;

  svg {
    margin-left: 10px;
    font-size: 1.5rem; /* Larger WhatsApp icon */
  }

  &:hover {
    background-color: #128c7e; /* Darker green on hover */
  }

  @media (max-width: 768px) {
    padding: 8px 12px;
    font-size: 0.9rem;
    svg {
        font-size: 1.3rem;
    }
  }
`;

export default Footer;